import { useTranslations } from 'next-intl'

/**
 * omnyqra: translated Suspense fallback shared by signup and password reset
 * (Omnyqra/sim#43), see FORK.md
 */
export function AuthLoadingText() {
  const t = useTranslations('auth.common')
  return <div className='flex min-h-[320px] items-center justify-center'>{t('loading')}</div>
}
